<template lang="pug">
  .job-agg-chart
    VueApexCharts(
      type="line"
      height="400"
      :options="chart.options"
      :series="chart.series"
    )
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'

  export default {
    components: {
      VueApexCharts,
    },
    props: ['aggData', 'categories', 'series'],
    data () {
      return {
        chart: {
          options: {
            xaxis: {
              categories: this.categories,
            },
            chart: {
              zoom: {
                enabled: false,
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                },
              },
            },
            colors: ['#FF4B00', '#005AFF', '#03AF7A', '#4DC4FF', '#F6AA00', '#FFF100', '#000000', '#990099', '#f25a86', '#84919E'],
          },
          series: this.series,
        },
      }
    },
    methods: {
      updateChart () {
        this.chart.options = { ...this.chart.options,
          ...{
            xaxis: {
              categories: this.categories,
            },
          },
        }

        this.chart = { ...this.chart,
          ...{
            series: this.series,
          },
        }
      },
    },
    watch: {
      aggData () {
        this.updateChart()
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/AggregateJobChart.vue